import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput as RecessTextInput, } from '@guildeducationinc/recess';
export const TextInput = ({ trimLeftOnBlur = true, trimRightOnBlur = true, ...props }) => {
    const handleOnBlur = (e) => {
        let value = e.target.value;
        if (trimLeftOnBlur) {
            value = value.trimStart();
        }
        if (trimRightOnBlur) {
            value = value.trimEnd();
        }
        props.onChange?.({ ...e, target: { ...e.target, value } });
    };
    return _jsx(RecessTextInput, { ...props, onBlur: handleOnBlur });
};
